import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { animationVariants } from "../../constants/animationVariants";
import "./Proyectos.css";
import lapilcha from "../../images/lapil.PNG";
import gym from "../../images/qspage.PNG";
import supermarket from "../../images/super.PNG"
import carac from "../../images/carac.PNG"

const Proyectos = () => {
  return (
    <motion.div
      className="proyectos-container"
      initial="initial"
      whileInView="animate"
      viewport={{ once: true, amount: 0.2 }}
    >
      <motion.div variants={animationVariants.fadeUp}>
        <h1 className="titulo">Proyectos Destacados</h1>
      </motion.div>
      <div className="parent">
        <motion.div className="divs" variants={animationVariants.fadeLeft}>
          <h3>Ecommerce</h3>
          <img
            src={lapilcha}
            alt="Ecommerce"
            title="Ecommerce"
            className="imagen"
          />
          <Link
            to="https://pf-la-pilcha.vercel.app"
            target="_blank"
            className="button"
          >
            Visitar proyecto
          </Link>
          <p className="texto">
            Esta aplicación permite a los usuarios registrarse, iniciar sesión,
            navegar, buscar productos, filtros, agregar productos a favoritos,
            añadir al carrito y pasarela de pago incluída.
          </p>
        </motion.div>

        <motion.div className="divs" variants={animationVariants.fadeRight}>
          <h3>Querubín Sistemas</h3>
          <img src={gym} alt="Proyecto Querubin Sistemas" className="imagen" />
          <Link
            to="https://querubin-sistemas.vercel.app"
            target="_blank"
            className="button"
          >
            Visitar proyecto
          </Link>
          <p className="texto">
            Página web donde ofrecemos servicios de Software con ex-compañero de
            Henry.
          </p>
        </motion.div>

        <motion.div className="divs" variants={animationVariants.fadeRight}>
          <h3>Caracas Digital</h3>
          <img
            src={carac}
            alt="Caracas Digital"
            title="Caracas Digital"
            className="imagen"
          />
          <Link
            to="http://caracasdigital.com"
            target="_blank"
            className="button"
          >
            Visitar sitio web
          </Link>
          <p className="texto">
            Página web de noticias relacionadas a tecnología y
            telecomunicaciones.
          </p>
        </motion.div>

        <motion.div className="divs" variants={animationVariants.fadeRight}>
          <h3>Supermercado</h3>
          <img
            src={supermarket}
            alt="Supermarket"
            title="Supermarket"
            className="imagen"
          />
          <Link
            to="https://supermarket-blue.vercel.app/"
            target="_blank"
            className="button"
          >
            Visitar proyecto
          </Link>
          <p className="texto">
            Sitio web realizado con Next V.14 y tailwind consumiendo una API
            rest de productos de supermercados.
          </p>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Proyectos;
